import React from "react";
import Icon, { IconProps } from "./Icon";
import { vars } from "@puzzle/theme";

export function CreditCardGradient({
  viewBox = "0 0 48 48",
  width = 48,
  height = 48,
  fill = "none",
  ...iconProps
}: IconProps) {
  return (
    <Icon height={height} width={width} fill={fill} {...iconProps} viewBox={viewBox}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
      >
        <path
          d="M5 20V35C5 37.2091 6.79086 39 9 39H39C41.2091 39 43 37.2091 43 35V20M5 20V13C5 10.7909 6.79086 9 9 9H39C41.2091 9 43 10.7909 43 13V20M5 20H43M13 27H19"
          stroke="url(#paint0_linear_103_11257)"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_103_11257"
            x1="7.77083"
            y1="11.8125"
            x2="33.5963"
            y2="42.967"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={vars.colors["surface-special-base"]} />
            <stop offset="1" stopColor={vars.colors["surface-primary-subdue"]} />
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
}
